module.exports = __webpack_public_path__ + "img/page-bg2.0cf0856d.jpg";